import { InputAdornment, Typography } from "@mui/material";
import type { FC } from "react";
import { NumericFormat } from "react-number-format";

import { MAX_CUSTOM_SPREAD_CENTS } from "../constants";
import * as Styled from "../SpreadFilter.styles";

interface SpreadCustomInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
}

export const SpreadCustomInput: FC<SpreadCustomInputProps> = ({
  value,
  onChange,
}) => (
  <Styled.CustomInputRow>
    <NumericFormat
      customInput={Styled.CustomTextField}
      value={value ?? ""}
      variant="outlined"
      size="small"
      allowNegative={false}
      decimalScale={2}
      isAllowed={({ floatValue }) =>
        floatValue === undefined ||
        (floatValue > 0 && floatValue <= MAX_CUSTOM_SPREAD_CENTS)
      }
      onValueChange={({ floatValue }) =>
        onChange(typeof floatValue === "number" ? floatValue : null)
      }
      placeholder="Custom"
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">{"\u00A2"}</InputAdornment>
          ),
        },
        htmlInput: {
          inputMode: "decimal",
        },
      }}
    />
    <Typography variant="caption" sx={{
      color: "text.secondary"
    }}>
      Max 100{"\u00A2"}
    </Typography>
  </Styled.CustomInputRow>
);
